import type { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import {
	ITEM_CLICKED,
	type ItemClickedAction,
	setRecentlyClickedItem,
} from '../../state/actions.tsx';
import {
	getOnBoardClick,
	getBoardById,
	isBoardInLocation,
	getViewAllUrl,
	getOnNavigateUrl,
} from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

export const ERROR = 'navigation-apps.scope-switcher-v2.item-click';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onItemClick: Epic<any, State> = (action$, store) =>
	action$.ofType(ITEM_CLICKED).mergeMap((action: ItemClickedAction) => {
		const { id, isViewAll } = action.payload;
		const state = store.getState();
		const onNavigateUrl = getOnNavigateUrl(state);

		// view all was clicked
		if (isViewAll) {
			onNavigateUrl(getViewAllUrl(state));
			return Observable.empty<never>();
		}

		// board was clicked
		const board = getBoardById(state, id);

		if (!board) {
			log.safeErrorWithoutCustomerData(ERROR, 'Tried to click on board which does not exist');
			return Observable.empty<never>();
		}

		const onBoardClick = getOnBoardClick(state);
		onBoardClick(board, isBoardInLocation(state, board));

		return Observable.of(setRecentlyClickedItem(id));
	});
